export default __webpack_public_path__ + "static/media/subhas.c4fe4500.jpg";